// extracted by mini-css-extract-plugin
export default {"question":"FAQ_question__Ty1o0","greenText":"FAQ_greenText__FO7CU","container":"FAQ_container__ZrdsP"};